module.exports = __webpack_public_path__ + "img/rating-5.0c380096.png";